import React from "react"; // eslint-disable-line no-unused-vars
// import { makeStyles } from "@material-ui/core/styles";

export default function CardPreview(props) {
  // const useStyles = makeStyles(
  //   () => ({
  //     cardImage: {
  //       backgroundRepeat: "no-repeat",
  //       backgroundColor: "transparent",
  //       borderRadius: "14px",
  //       border: "1px solid #d8d8d8",
  //       backgroundSize: "cover",
  //       overflow: "hidden",
  //     },
  //     overlay: {
  //       width: "100%",
  //       display: "block",
  //     },
  //   })
  // );
  // const classes = useStyles();

  return (
    <div
      className={props.classes.cardpreviewcardImage}
      style={{
        backgroundImage: "url('" + props.selectedCardImage + "')",
      }}
    >
      <img
        className={props.classes.cardpreviewoverlay}
        src={props.cardOverlay}
        alt="Card Preview"
      />
    </div>
  );
}
